import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import WarehouseReleaseDetails from 'containers/WarehouseReleases/WarehouseReleaseDetails/WarehouseReleaseDetails';
import WarehouseReleasesDashboard from 'containers/WarehouseReleases/WarehouseReleasesDashboard';
function WarehouseReleases() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(WarehouseReleasesDashboard, null) }),
        React.createElement(Route, { path: ":warehouseReleaseId/*", element: React.createElement(WarehouseReleaseDetails, null) })));
}
export default memo(WarehouseReleases);
